import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/allen-school-ui_main/packages/school/app/layout.tsx");
